import React, { FC } from 'react';
import CheckboxItem from 'ui/MultipleSelect/CheckboxItem';

interface IDropdownItem {
  name: string;
  label: string;
  filterFormData: any;
  setFilterFormData: (state: any) => void;
  setFilterFormErrors: (state: any) => void;
}

const DropdownItem: FC<IDropdownItem> = ({
  name,
  label,
  filterFormData,
  setFilterFormData,
  setFilterFormErrors,
}: IDropdownItem) => {
  return (
    <li className="multiple-select__dropdown-item">
      <CheckboxItem
        id={label}
        name={name}
        label={label}
        isChecked={filterFormData[name].some((item: string) => item === label)}
        setFilterFormData={setFilterFormData}
        setFilterFormErrors={setFilterFormErrors}
      />
    </li>
  );
};

export default React.memo(DropdownItem);
